import { ActionStatus, FACTION_NAMES, Room } from '../../../Constants';
import {
    availableLodging,
    clockedInTempStaff,
    clockOutableStaff,
    consumeLodgingTileOptimistically,
    emptyLodgingCount,
    firstUnupgradedLodging,
    hasUnupgradedLodging, isThisLodgingAvailableInPool,
    maxTradelaneFaction, needyGuests
} from '../../Game/GamePlayerInfo';
import { CARD_FACTIONS } from '../../TwoD/Common/CardUtilities';


function doIhaveFate(gamePlayerController, aiPackage) {
    const currentFate = gamePlayerController.gamePlayerData.current_fate;
    const result = currentFate > 0;
    const question = 'What about Fate?'
    let reason = 'There is no Fate but what we make'
    if (result) {
        reason = `I have Fate (${currentFate}), Now I must Act.`;
        aiPackage.complete = false;
    } else {
        aiPackage.addToMessage('There is no Fate but what we make');
        aiPackage.complete = true;
        if (aiPackage.execute) gamePlayerController.gamePlayerApi.lodgingJuice([]);
    }
    aiPackage.addProvenance(question, result, reason);
    return result;
}

function shouldIJuiceLodging(gamePlayerController, aiPackage) {
    // attack or build matters....
    // I want 2, 3, 4, 5, 6, 7, 8;
    let available = clockOutableStaff(gamePlayerController.gamePlayerData);
    let result = available.length > 0
    let question = 'Do I have available staff for Clock-Out?'
    let reason = 'There are none available.'
    if (result) {
        reason = `There are ${available.length} available.`;
    }
    aiPackage.addProvenance(question, result, reason);
    if (!result) return false;

    let want = 2;
    const current = clockedInTempStaff(gamePlayerController.gamePlayerData).length;
    result = current > want
    question = 'Clock-Out Available Staff to Juice?'
    reason = `I want ${want} and I have ${current}.`;
    aiPackage.addProvenance(question, result, reason);
    return result;
}


function shouldIAttackLodging(gamePlayerController, aiPackage) {
    // todo: glean condition from config
    const question = 'Should I Attack?'
    const reason = `As to not waste an action.`;
    aiPackage.addProvenance(question, true, reason);
    return true;
}


function shouldIAddLodging(gamePlayerController, aiPackage) {
    // todo: glean condition from config
    const emptyLodging = emptyLodgingCount(gamePlayerController.gamePlayerData);
    let result = emptyLodging > 0;
    aiPackage.provenance.push(`Do I have room? (${emptyLodging} spots) > (0) == ${result}`);
    const question = 'Almost Full of Lodging?'
    const reason = `${emptyLodging} < ${2}`;
    aiPackage.addProvenance(question, result, reason);

    return result;
}


function shouldIUpgradeLodging(gamePlayerController, aiPackage) {
    // todo: glean condition from config
    let question, answer, reasoning;
    let success = false;
    if (emptyLodgingCount(gamePlayerController.gamePlayerData) > 0) {
        const needy = needyGuests(gamePlayerController.gamePlayerData);
        question = 'Do I have a Guest in need of Lodging?';
        answer = needy.length > 0
        reasoning = 'If there is already a Guest in need, get their Lodging.'
        aiPackage.addProvenance(question, answer, reasoning);
        if (answer) {
            return false;
        }
    }

    if (!success) {
        const result = hasUnupgradedLodging(gamePlayerController.gamePlayerData);
        question = 'Can I Upgrade?'
        reasoning = `I upgrade rather than add.`;
        answer = result;
        aiPackage.addProvenance(question, answer, reasoning);
        return result;
    }
}

function setJuice(gamePlayerController, aiPackage) {
    let clockedOutStaff = [];
    const staffMember = clockOutableStaff(gamePlayerController.gamePlayerData).pop();
    clockedOutStaff.push(staffMember);
    aiPackage.clockedOutStaff = clockedOutStaff
    aiPackage.addToMessage(`Clock Out Staff #${staffMember}`);
}

function attackTarget(gamePlayerController, aiPackage) {
    let message = '';
    let target = null;
    let orderedPlayers = [ ...gamePlayerController.gameData.gameplayer_set ].filter(
        player => player.id !== gamePlayerController.gamePlayerData.id).filter(
        player => player.lodging[0] !== null
    );
    if (orderedPlayers.length > 0) {
        orderedPlayers.sort((a, b) => a.current_score - b.current_score);
        target = orderedPlayers.pop();
        if (target) {
            message = `Target -> ${target.name}-${target.seat}`;
            aiPackage.addToMessage(message);
            aiPackage.complete = true;
            const question = 'Who has the highest score?'
            const answer = `${target.name}-${target.seat}`;
            aiPackage.addProvenance(question, answer, 'Seek the strongest.');
        }

    }

    if (!target) {
        aiPackage.addToMessage('No suitable target, Skip');
    }

    if (aiPackage.execute && target) {
        // clockedOutStaff || []: an undefined sold_robots is dropped on the
        // wire and the engine reads the player_target-only click as a stale
        // pre-roll target commit (see upgrade()).
        gamePlayerController.gamePlayerApi.lodgingFullAction(
            aiPackage.clockedOutStaff || [],
            target.id,
            null,
            null
        )
    } else if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickNext();
    }
}


function upgrade(gamePlayerController, aiPackage) {
    let message = 'Upgrade ';
    let lodgingIndex = firstUnupgradedLodging(
        gamePlayerController.gamePlayerData);
    let roomId = gamePlayerController.gamePlayerData.lodging[lodgingIndex];
    let roomName = Room.NAMES[roomId];
    aiPackage.addProvenance(
        'What is the first unupgraded Lodging.',
        roomName,
        'I like fancy things.');
    message += roomName;
    if (aiPackage.execute) {
        // sold_robots MUST be an array on the wire. When the seat did not
        // clock out (shouldIJuiceLodging false), aiPackage.clockedOutStaff is
        // undefined, and lodgingFullAction(undefined, ...) serializes to
        // sold_robots: undefined -> JSON.stringify DROPS the key. The engine's
        // extract_sold_robots then finds no sold_robots but sees player_target
        // and reads the click as a stale pre-roll target commit, firing the
        // user-facing STALE_TARGET_COMMIT_AT_WAIT_FOR_JUICE Reject on every
        // self-spend that didn't juice. || [] sends the legal empty clock-out
        // (mirrors attackSpendOnCommittedTarget and AIAntiJuice).
        gamePlayerController.gamePlayerApi.lodgingFullAction(
            aiPackage.clockedOutStaff || [],
            gamePlayerController.gamePlayerData.id,
            null,
            lodgingIndex
        )
    }
    aiPackage.addToMessage(message);
    aiPackage.complete = true;
}


function aiAddLodging(gamePlayerController, aiPackage) {
    let message = 'Add ';
    let question, answer, reasoning;
    let factionId, factionIndex;
    // Do I have a guest in need?

    const needy = needyGuests(gamePlayerController.gamePlayerData);
    question = 'Do I have a Guest in need of Lodging?';
    answer = needy.length > 0
    reasoning = 'If there is already a Guest in need, get their Lodging.'
    aiPackage.addProvenance(question, answer, reasoning);
    if (answer) {
        const cardId = needy.pop();
        factionId = CARD_FACTIONS[cardId];
        factionIndex = factionId - 1;
        aiPackage.success = isThisLodgingAvailableInPool(
            gamePlayerController.gameData, factionId);
    }

    if (!aiPackage.success) {
        factionId = maxTradelaneFaction(gamePlayerController.gameData);
        factionIndex = factionId - 1;
        question = `Of the first 4 columns, which Faction is most represented?`;
        reasoning = 'I want Lodging which is immediately relevant.'
        answer = FACTION_NAMES[factionIndex];
        aiPackage.addProvenance(question, answer, reasoning);
        aiPackage.success = isThisLodgingAvailableInPool(
            gamePlayerController.gameData, factionId);
    }

    if (!aiPackage.success) {
        question = 'What is the First available Lodging?';
        answer = 'None Available';
        reasoning = 'All other methods did not work.';
        let orderedFactions = [...aiPackage.actionPreferences];
        orderedFactions.shift(); // remove myself (should be first);
        let foundFaction = null;
        const available = availableLodging(gamePlayerController.gameData);
        while (orderedFactions.length > 0 && !foundFaction) {
            let faction = orderedFactions.shift();
            if (available.includes(faction)) foundFaction = faction;
        }
        if (foundFaction !== null) {
            factionId = foundFaction;
            factionIndex = factionId - 1;
            answer = FACTION_NAMES[factionIndex];
            aiPackage.success = true;
        }
        aiPackage.addProvenance(question, answer, reasoning);
    }

    if (!aiPackage.success) {
        // Legal beats optimal. The preference walk above shifts the
        // seat's OWN faction off the front, so a pool where only the
        // seat's faction still has stock walks empty and falls through
        // here — the exact game-807 (2026-06-05) silence: row 0 held
        // four faction-1 tiles but the seat was faction 1, so neither
        // the preference walk nor an off-faction maxTradelane found
        // them. Add ANY faction the pool can still supply. The
        // validate-first engine rejects a genuinely illegal pick with
        // valid_options and the retry net recovers; going silent strands
        // the seat at ADD_ID forever.
        const anyAvailable = availableLodging(gamePlayerController.gameData);
        if (anyAvailable.length > 0) {
            factionId = anyAvailable[0];
            factionIndex = factionId - 1;
            aiPackage.success = true;
            aiPackage.addProvenance(
                'Any Faction with Lodging stock?',
                FACTION_NAMES[factionIndex],
                'Legal beats optimal — add whatever the pool offers.');
        }
    }

    if (!aiPackage.success) {
        aiPackage.addToMessage('No Lodging available in pool.');
        return;
    }

    let roomId = Room.UNUPGRADED_LODGING_IDS[factionIndex];
    let roomName = Room.NAMES[roomId];
    message += roomName;
    if (aiPackage.execute) {
        // clockedOutStaff || []: an undefined sold_robots is dropped on the
        // wire and the engine reads the player_target-only click as a stale
        // pre-roll target commit (see upgrade()).
        gamePlayerController.gamePlayerApi.lodgingFullAction(
            aiPackage.clockedOutStaff || [],
            gamePlayerController.gamePlayerData.id,
            factionId,
            null
        )
        // Optimistically deplete the stale frontend pool so a follow-up
        // add this round (recursive per-fate, or another seat sharing this
        // browser's gameData) doesn't re-pick a faction whose tiles the
        // engine has already handed out. See
        // consumeLodgingTileOptimistically.
        consumeLodgingTileOptimistically(
            gamePlayerController.gameData, factionId);
    }
    aiPackage.addToMessage(message);
    aiPackage.complete = true;
}


function addOrUpgrade(gamePlayerController, aiPackage) {
    if (!aiPackage.complete && shouldIUpgradeLodging(gamePlayerController, aiPackage)) {
        upgrade(gamePlayerController, aiPackage);
    }

    if (!aiPackage.complete && shouldIAddLodging(gamePlayerController, aiPackage)) {
        aiAddLodging(gamePlayerController, aiPackage);
    }

    if (!aiPackage.complete) {
        // The engine parks the seat at ADD_ID (lodging_action.wait_for_add)
        // until a click arrives, and process_ai_choice does NOT drive an
        // FE-AI seat — so a silent return here stalls the seat forever
        // (game 807, 2026-06-05). When there is nothing to upgrade and no
        // faction stock to add, decline explicitly: a 'Next' click routes
        // through action_router.receive_action -> skip_button ->
        // finish_action and legally ends the action with any unspent Fate
        // forfeited — the same decline AIGhostAction's aiRemoveGhost emits
        // when there is no ghost left to clear.
        aiPackage.addToMessage('No Lodging to add or upgrade; ending action.');
        aiPackage.complete = true;
        if (aiPackage.execute) {
            gamePlayerController.gamePlayerApi.clickNext();
        }
    }

    if (aiPackage.complete) {
        aiPackage.success = true;
    }
    return aiPackage;
}

function pickLodgingOpponent(gamePlayerController, aiPackage) {
    // Same shape as attackTarget's selection block — highest-score
    // opponent with non-empty lodging — but returns the target object
    // instead of firing a spend. Used by both the pre-roll INIT
    // target commit and the post-roll WAIT_FOR_JUICE spend.
    let orderedPlayers = [...gamePlayerController.gameData.gameplayer_set]
        .filter(player => player.id !== gamePlayerController.gamePlayerData.id)
        .filter(player => player.lodging[0] !== null);
    if (orderedPlayers.length === 0) return null;
    orderedPlayers.sort((a, b) => a.current_score - b.current_score);
    const target = orderedPlayers.pop();
    if (target) {
        aiPackage.addProvenance(
            'Who has the highest score?',
            `${target.name}-${target.seat}`,
            'Seek the strongest.');
    }
    return target || null;
}


function aiLodgingCommitTarget(gamePlayerController, aiPackage) {
    // Manual §7.2.2 pre-roll target commit. current_fate is zero at
    // INIT — we cannot peek at it. Decision rule: if self-spend
    // (upgrade or add) would fire post-roll, target = self; else
    // target = opponent (via attack selection); fall back to self if
    // no viable opponent.
    let target_id = null;
    const my_id = gamePlayerController.gamePlayerData.id;
    // No `current_action_target` early-return. This handler runs ONLY at
    // INIT_ID / WAIT_FOR_TARGET_ID, and at those states the SERVER's
    // current_action_target is None by the state machine — a committed target
    // means the engine already rolled to WAIT_FOR_JUICE, which the switch
    // routes to aiLodgingWaitForJuice, not here. So any non-null
    // current_action_target visible in the snapshot at this point is STALE FE
    // data (a torn/partial patch, or leftover the seat has not cleared). The
    // old guard treated that stale value as "already committed" and returned
    // in SILENCE — no click, so no engine patch, no Reject, and the empowered
    // re-drive fallback (CC_FEAI_EMPOWERED_CURRENT_SEAT_STALL) latched off
    // against the unchanged decision state. The seat parked forever on the
    // target picker (G117, 2026-07-12: reload did nothing; a MANUAL target
    // click — the commit the engine was actually waiting for — unlocked it).
    // Fix: ignore the stale value and commit a fresh target below. The
    // duplicate risk is owned by the per-action commit fence just below.
    // Always-act: HSH_STYLE §AI always-act ("a silent return is the only
    // illegal move").
    //
    // CC_FEAI_MIDACTION_REDRIVE_THRASH (prod G152, 2026-07-14): the fence is a
    // SESSION-LEVEL "committed once this Lodging action" flag, NOT a
    // per-action_status key. The engine emits TWO pre-roll broadcasts for one
    // opportunity: action_router._execute broadcasts {status:LODGING,
    // action_status:INIT}, then lodging_action.commit_target (the select-action
    // click carried no player_target) flips to WAIT_FOR_TARGET_ID and
    // broadcasts AGAIN. The switch routes BOTH INIT and WAIT_FOR_TARGET to this
    // handler, so the old `commit:${action_status}` key — with a DISTINCT value
    // per state — let the seat commit at INIT and AGAIN at WAIT_FOR_TARGET. The
    // second commit reaches the engine after the first already rolled it to
    // WAIT_FOR_JUICE, and juice() reads the bare player_target as a stale
    // pre-roll commit -> the user-facing STALE_TARGET_COMMIT_AT_WAIT_FOR_JUICE
    // Reject (the ERROR reject-storm across every seat of prod G152). The same
    // flag also fences any empowered-fallback / diff-gate / reject-retry
    // re-drive of a LAGGED pre-roll snapshot (G127 / G136). One target commit
    // per action, whichever pre-roll broadcast the FE happens to drive first.
    // The flag is CLEARED centrally in ArtificialPlayer.updateEvent when the
    // seat leaves LODGING_ID status — a lag-proof per-action boundary: the
    // engine sets status=LODGING for the WHOLE action (action_router._execute)
    // and clears it to TAKING_TURN only at finish_action, so status cannot
    // regress mid-action the way action_status snapshots can. A later Lodging
    // action in the same turn re-enters LODGING with the flag cleared and
    // commits fresh. The reset canNOT live here (this handler only runs while
    // status===LODGING, so it can never observe the seat leaving it) — that is
    // exactly why the old in-handler `reset once action_status leaves the
    // commit phase` cleared too early and reopened the hole. See
    // AIGhostAction.aiGhostCommitTarget (verbatim mirror).
    if (gamePlayerController._lodgingCommitDone) {
        aiPackage.addToMessage(
            'Lodging target already committed this action; '
            + 'skipping duplicate pre-roll commit.');
        aiPackage.complete = true;
        aiPackage.success = true;
        return aiPackage;
    }
    const canUpgrade = shouldIUpgradeLodging(
        gamePlayerController, aiPackage);
    const canAdd = shouldIAddLodging(gamePlayerController, aiPackage);
    if (canUpgrade || canAdd) {
        target_id = my_id;
        aiPackage.addToMessage('Pre-roll Target -> Self');
    } else {
        const opponent = pickLodgingOpponent(
            gamePlayerController, aiPackage);
        if (opponent) {
            target_id = opponent.id;
            aiPackage.addToMessage(
                `Pre-roll Target -> ${opponent.name}-${opponent.seat}`);
        } else {
            target_id = my_id;
            aiPackage.addToMessage(
                'Pre-roll Target -> Self (no opponent available)');
        }
    }
    aiPackage.complete = true;
    aiPackage.success = true;
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.lodgingCommitTarget(target_id);
        // CC_FEAI_MIDACTION_REDRIVE_THRASH: latch that this Lodging action has
        // committed its one pre-roll target. Every subsequent pre-roll drive
        // (the WAIT_FOR_TARGET re-prompt broadcast, or any empowered/diff-gate/
        // reject-retry re-drive off a lagged snapshot) is fenced above until the
        // seat leaves LODGING_ID and ArtificialPlayer.updateEvent clears it.
        gamePlayerController._lodgingCommitDone = true;
    }
    return aiPackage;
}


function attackSpendOnCommittedTarget(gamePlayerController, aiPackage) {
    // Target was already committed pre-roll; we just spend staff
    // here. lodgingFullAction with target=committed-target still
    // works (engine ignores the field once current_action_target is
    // persisted), but we mirror fossa: just send a Juice click with
    // sold_robots and let the backend route to apply_attack.
    aiPackage.addToMessage('Spend on committed opponent target');
    aiPackage.complete = true;
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.lodgingJuice(
            aiPackage.clockedOutStaff || []);
    }
}


function aiLodgingWaitForJuice(gamePlayerController, aiPackage) {
    // Target is already persisted on current_action_target (committed
    // at INIT). This phase makes the juice (clock-out) decision and
    // dispatches spend against the committed target — no
    // target-picking here.

    doIhaveFate(gamePlayerController, aiPackage);

    if (!aiPackage.complete && shouldIJuiceLodging(gamePlayerController, aiPackage)) {
        setJuice(gamePlayerController, aiPackage);
    }

    const target_id = gamePlayerController.gamePlayerData.current_action_target;
    const my_id = gamePlayerController.gamePlayerData.id;
    if (target_id === my_id) {
        addOrUpgrade(gamePlayerController, aiPackage);
    } else if (target_id !== null && target_id !== undefined) {
        attackSpendOnCommittedTarget(gamePlayerController, aiPackage);
    } else {
        // Defensive: no target committed. Fall back to legacy in-step
        // decision (should not occur after CC_FATE_ORDER_FRONTEND).
        addOrUpgrade(gamePlayerController, aiPackage);
        if (!aiPackage.complete && shouldIAttackLodging(
                gamePlayerController, aiPackage)) {
            attackTarget(gamePlayerController, aiPackage);
        }
    }

    aiPackage.success = true;
    return aiPackage;
}


export default function artificialLodgingAction(gamePlayerController, aiPackage) {
    // CC_FEAI_MIDACTION_REDRIVE_THRASH: the pre-roll commit fence
    // (_lodgingCommitDone) is NOT reset here. This handler only runs while the
    // seat's status is LODGING_ID, so it can never observe the seat leaving the
    // action — the old reset keyed on action_status and cleared the moment the
    // seat left the commit phase (INIT -> WAIT_FOR_JUICE), which reopened the
    // door for a lagged pre-roll re-drive (or the WAIT_FOR_TARGET re-prompt
    // broadcast) to double-commit and trip stale_target_commit. The reset now
    // lives in ArtificialPlayer.updateEvent, keyed on the seat's LIVE status
    // leaving LODGING_ID — a lag-proof per-action boundary. See
    // aiLodgingCommitTarget.
    switch (gamePlayerController.gamePlayerData.action_status) {
    case ActionStatus.INIT_ID:
        aiLodgingCommitTarget(gamePlayerController, aiPackage);
        return aiPackage;
    case ActionStatus.WAIT_FOR_TARGET_ID:
        aiLodgingCommitTarget(gamePlayerController, aiPackage);
        return aiPackage;
    case ActionStatus.WAIT_ID:
        aiPackage.addToMessage('Lodging Confirm');
        // gamePlayerController.clickConfirmLodigng();
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.FATE_MINIGAME_ID:
        aiPackage.addToMessage('Lodging Fate Choice Not Supported');
        // todo: cause the backend to not care about this package type.
        // gamePlayerController.lodgingFateMinigameChoice();
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.FATE_MINIGAME_DONE_ID:
        aiPackage.addToMessage('Lodging Fate Response Not Supported');
        // gamePlayerController.lodgingFateMinigameDone();
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.WAIT_FOR_JUICE:
        aiLodgingWaitForJuice(gamePlayerController, aiPackage);
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.JUICE_ID:
        aiPackage.addToMessage('Lodging Status Juice not supported');
        return aiPackage;
    case ActionStatus.ADD_ID:
        return addOrUpgrade(gamePlayerController, aiPackage);
    case ActionStatus.ATTACKING_ID:
        aiPackage.addToMessage('Lodging Attack Underway');
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.DONE_ID:
        aiPackage.addToMessage('Lodging Done Confirmation Not Supported');
        aiPackage.success = true;
        return aiPackage;
    default:
        console.error('Lodging Too Far.', gamePlayerController.gamePlayerData.action_status);
        break;
    }
}
